// Mock data para la landing page de Jhon Cesar

export const heroData = {
  badges: [
    "Filmmaker & Director",
    "Edición & Post-Producción",
    "Estrategia de Contenido",
    "Social Media Manager"
  ],
  title: "HISTORIAS QUE",
  titleHighlight: "VENDEN.",
  subtitle: "Soy filmmaker y estratega de contenido. Produzco, dirijo y edito videos diseñados para posicionar tu marca, retener audiencias y convertir seguidores en clientes.",
  videoUrl: "https://www.youtube.com/embed/P9Ohqca2qN4?autoplay=1&mute=1&controls=1&rel=0&modestbranding=1",
  buttons: [
    { text: "Ver Portfolio", primary: true, link: "#portfolio" },
    { text: "Contactar", primary: false, link: "#contacto" }
  ]
};

export const stats = [
  { value: "+75M", label: "Visitas Generadas" },
  { value: "+45", label: "Clientes Satisfechos" },
  { value: "5.0★", label: "Rating Cliente" }
];

export const clients = [
  {
    name: "Alejandroperez",
    subscribers: "@soyjelalejandroperez",
    logo: "AP",
    logoSrc: "/logos/Alejandroperez.png"
  },
  {
    name: "BeeaniEnglish",
    subscribers: "@beeanienglish",
    logo: "BE",
    logoSrc: "/logos/BeeaniEnglish.png"
  },
  { name: "Colegio Más Luz", subscribers: "@colegiomasluz", logo: "CML", logoSrc: "/logos/ColegioMasLuz.png" },
  { name: "EDTécnica", subscribers: "@ED.Tecnica", logo: "EDT", logoSrc: "/logos/EDT.png" },
  { name: "EDTplus", subscribers: "@EDTplus.ve", logo: "EDTP", logoSrc: "/logos/EDTPLUS.png" },
  { name: "Estudio Suken", subscribers: "@estudiosuken", logo: "ES", logoSrc: "/logos/Estudio Suken.png" },
  { name: "Indawork", subscribers: "@inda.work", logo: "IW", logoSrc: "/logos/Indawork.png" },
  { name: "Joaquin Marker", subscribers: "@joaquinmarker", logo: "JM", logoSrc: "/logos/Joaquin Marker.png" },
  { name: "Luma profesional", subscribers: "@lumaprofesional", logo: "LP", logoSrc: "/logos/Luma profesional.png" },
  {
    name: "QueMate",
    subscribers: "@quemate.arg",
    logo: "QM",
    logoSrc: "/logos/QueMate.png"
  },
  { name: "Rolitornillos", subscribers: "@rolitornillos", logo: "RT", logoSrc: "/logos/Rolitornillos.png" },
  { name: "kukyMotos", subscribers: "@kukymotos.ve", logo: "KM", logoSrc: "/logos/kukyMotos.png" }
];

// Portfolio items updated: each item includes `instagramReels` (embed-ready URLs)
export const portfolioItems = [
  {
    id: "joaquin",
    title: "Joaquin",
    thumbnail: "/placeholder.svg",
    category: "Cliente",
    result: "Proyectos destacados",
    summary: "Reels y contenidos para redes",
    format: "Reels",
    href: "#",
    theme: "from-zinc-950 via-neutral-900 to-sky-700",
    accent: "bg-sky-400",
    instagramReels: [
      { videoUrl: "https://www.instagram.com/reel/DSD5oL3ji-Y/", thumbnailUrl: "/placeholder.svg" },
      { videoUrl: "https://www.instagram.com/reel/DZI6R5ZSAtO/", thumbnailUrl: "/placeholder.svg" },
    ]
  },
  {
    id: "edt",
    title: "EDT",
    thumbnail: "/placeholder.svg",
    category: "Cliente",
    result: "Campañas institucionales",
    summary: "Reels optimizados para conversión",
    format: "Reels",
    href: "#",
    theme: "from-zinc-950 via-slate-900 to-emerald-700",
    accent: "bg-emerald-400",
    instagramReels: [
      { videoUrl: "https://www.instagram.com/reel/DR210H8kqf1/", thumbnailUrl: "/placeholder.svg" },
      { videoUrl: "https://www.instagram.com/reel/DJEsmmpurmI/", thumbnailUrl: "/placeholder.svg" },
    ]
  },
  {
    id: "indawork",
    title: "IndaWork",
    thumbnail: "/placeholder.svg",
    category: "Cliente",
    result: "Contenidos B2B",
    summary: "Reels para posicionamiento",
    format: "Reels",
    href: "#",
    theme: "from-stone-950 via-zinc-900 to-amber-700",
    accent: "bg-amber-400",
    instagramReels: [
      { videoUrl: "https://www.instagram.com/reel/C3puXs_At0H/", thumbnailUrl: "/placeholder.svg" },
    ]
  },
  {
    id: "luma",
    title: "Luma",
    thumbnail: "/placeholder.svg",
    category: "Cliente",
    result: "Producción premium",
    summary: "Reels con acabado cinematográfico",
    format: "Reels",
    href: "#",
    theme: "from-zinc-950 via-slate-900 to-rose-700",
    accent: "bg-rose-400",
    instagramReels: [
      { videoUrl: "https://www.instagram.com/reel/DWuAfC2CXam/", thumbnailUrl: "/placeholder.svg" },
      { videoUrl: "https://www.instagram.com/reel/DXSyoxbCU9F/", thumbnailUrl: "/placeholder.svg" },
    ]
  },
  {
    id: "rolitornillos",
    title: "Rolitornillos",
    thumbnail: "/placeholder.svg",
    category: "Cliente",
    result: "Contenido técnico",
    summary: "Reels demostrativos y promocionales",
    format: "Reels",
    href: "#",
    theme: "from-zinc-950 via-slate-900 to-cyan-700",
    accent: "bg-cyan-400",
    instagramReels: [
      { videoUrl: "https://www.instagram.com/reel/DZDhHRuD7Nx/", thumbnailUrl: "/placeholder.svg" },
      { videoUrl: "https://www.instagram.com/reel/DISflVvv6qy/", thumbnailUrl: "/placeholder.svg" },
    ]
  },
  {
    id: "kukymotos",
    title: "KuKyMotos",
    thumbnail: "/placeholder.svg",
    category: "Cliente",
    result: "Campañas para ecom",
    summary: "Reels orientados a venta",
    format: "Reels",
    href: "#",
    theme: "from-zinc-950 via-neutral-900 to-fuchsia-700",
    accent: "bg-fuchsia-400",
    instagramReels: [
      { videoUrl: "https://www.instagram.com/reel/DXrPmLcAI-r/", thumbnailUrl: "/placeholder.svg" },
    ]
  },
  {
    id: "cliente_adicional",
    title: "Otros Proyectos Destacados",
    thumbnail: "/placeholder.svg",
    category: "Varios",
    result: "Colección de reels",
    summary: "Proyectos adicionales",
    format: "Reels",
    href: "#",
    theme: "from-zinc-950 via-slate-900 to-sky-700",
    accent: "bg-sky-400",
    instagramReels: [
      { videoUrl: "https://www.instagram.com/reel/DYh7pFMxEVT/", thumbnailUrl: "/placeholder.svg" },
    ]
  }
];


export const audienceTestimonials = [
  {
    text: "Más que un video, parece una película. Qué locura de producción y qué gran trabajo.",
    author: "@marketingguru",
    role: "Espectador"
  },
  {
    text: "Increíble, este contenido me ayudó a triplicar mis ventas.",
    author: "@emprendedor23",
    role: "Espectador"
  },
  {
    text: "La forma en la que está contado me mantuvo enganchado hasta el final.",
    author: "@creativostudio",
    role: "Espectador"
  },
  {
    text: "Me encantó todo: la edición, el mensaje y la estrategia detrás.",
    author: "@digitalcreator",
    role: "Espectador"
  },
  {
    text: "Increíble la calidad y el profesionalismo en cada detalle.",
    author: "@brandbuilder",
    role: "Espectador"
  },
  {
    text: "La calidad del contenido es impecable en todo sentido.",
    author: "@contentmaster",
    role: "Espectador"
  },
  {
    text: "La mejor inversión que hice para mi negocio este año.",
    author: "@businessowner",
    role: "Espectador"
  },
  {
    text: "Sinceramente, era el contenido que necesitaba. Gran trabajo.",
    author: "@socialmedia",
    role: "Espectador"
  }
];

export const clientTestimonials = [
  {
    text: "Brutal el resultado. Muy buen trabajo de verdad, el listón estaba muy alto y lo has superado con creces.",
    author: "María González",
    role: "CEO, TechVision",
    avatar: "MG",
    subscribers: "2.5M subs"
  },
  {
    text: "Esto está de locos. No he encontrado a nadie que haga lo que tú haces con el nivel de detalle y estrategia.",
    author: "Carlos Rodríguez",
    role: "Founder, Marketing Pro",
    avatar: "CR",
    subscribers: "890K subs"
  },
  {
    text: "El video quedó brutal y la campaña generó 4M de impresiones. Superó todas las expectativas.",
    author: "Ana Martínez",
    role: "CMO, Digital Creators",
    avatar: "AM",
    subscribers: "1.2M subs"
  },
  {
    text: "Te has adaptado rapidísimo a nuestra marca y ya hemos conseguido resultados increíbles.",
    author: "Luis Fernández",
    role: "Director, Brand Studio",
    avatar: "LF",
    subscribers: "654K subs"
  },
  {
    text: "Muy buen trabajo, exactamente lo que pedí. Lo entendió todo a la primera.",
    author: "Sofia Torres",
    role: "CEO, Content Masters",
    avatar: "ST",
    subscribers: "3.1M subs"
  },
  {
    text: "Trabajo profesional y entrega rápida. Ha mejorado significativamente nuestro engagement.",
    author: "David Sánchez",
    role: "Founder, Video Labs",
    avatar: "DS",
    subscribers: "445K subs"
  }
];

export const processSteps = [
  {
    number: "01",
    title: "Análisis Estratégico",
    description: "Audito tu marca, tu audiencia y tu comunicación actual. Identifico los puntos de fricción que frenan tu crecimiento y definimos juntos los objetivos reales: posicionamiento, conversión o autoridad.",
    tags: ["Auditoría", "Análisis de Audiencia", "Definición de Objetivos"]
  },
  {
    number: "02",
    title: "Estrategia de Contenido",
    description: "Diseño el sistema completo: pilares de contenido, narrativa de marca, guiones y estructura de publicación. Todo bajo los principios de valor, venta y branding.",
    tags: ["Concepto Creativo", "Guión", "Storyboard"]
  },
  {
    number: "03",
    title: "Producción & Dirección",
    description: "Dirijo la grabación con criterio cinematográfico y estratégico. Cada toma está pensada para capturar exactamente lo que tu marca necesita comunicar.",
    tags: ["Dirección", "Grabación", "Coordinación"]
  },
  {
    number: "04",
    title: "Edición & Post-Producción",
    description: "Aquí el material cobra vida: montaje dinámico, motion graphics, color grading y sound design. Todo optimizado para retener la atención en tu plataforma objetivo.",
    tags: ["Montaje", "Motion Graphics", "Sound Design", "Color Grading"]
  },
  {
    number: "05",
    title: "Optimización & Entrega",
    description: "Analizo el rendimiento, ajusto la estrategia y entrego métricas claras. El contenido evoluciona con tu marca — no se publica y se olvida.",
    tags: ["Optimización", "Feedback", "Estrategia de Lanzamiento"]
  }
];

export const faqs = [
  {
    question: "¿Qué tipo de proyectos manejas?",
    answer: "Trabajo en edición de video para YouTube, redes sociales, publicidad digital, VSLs (Video Sales Letters), contenido educativo y campañas de marketing digital completas. Desde videos cortos hasta producciones largas con estrategia integral."
  },
  {
    question: "¿Participas solo en la edición o también en la estrategia?",
    answer: "Ofrezco ambos servicios. Puedo trabajar únicamente en la edición si ya tienes tu estrategia definida, o puedo desarrollar la estrategia completa de contenido y marketing desde cero, incluyendo concepto, guión, edición y plan de distribución."
  },
  {
    question: "¿Cómo desarrollas la estrategia de un proyecto?",
    answer: "Primero hago un análisis profundo de tu marca, audiencia y competencia. Luego defino objetivos claros y KPIs. Desarrollo el concepto creativo, estructura narrativa y plan de contenido. Todo está pensado para generar resultados medibles."
  },
  {
    question: "¿Cuánto tarda un proyecto?",
    answer: "Depende de la complejidad. Videos cortos (1-3 min): 3-5 días. Videos de YouTube (8-15 min): 1-2 semanas. Proyectos complejos con estrategia completa: 2-4 semanas. Siempre cumplo con los plazos acordados."
  },
  {
    question: "¿Cómo funciona el proceso de revisión?",
    answer: "Utilizo plataformas profesionales donde puedes comentar directamente en el timeline del video. Esto hace el feedback súper preciso y rápido. Incluyo 2-3 rondas de revisión según el paquete contratado."
  },
  {
    question: "¿Trabajas con clientes internacionales?",
    answer: "Sí, trabajo con clientes de todo el mundo. La comunicación es principalmente por videollamadas y herramientas colaborativas. He trabajado con marcas en España, México, Colombia, Argentina, Estados Unidos y más países."
  }
];

export const contactOptions = [
  {
    value: "vertical",
    label: "Formato vertical para redes sociales",
    price: "Desde 75$ hasta 450$",
    hasSubOptions: true,
    subOptions: [
      { value: "30seg", label: "30 segundos" },
      { value: "60seg", label: "60 segundos" },
      { value: "180seg", label: "180 segundos (3 min)" }
    ]
  },
  { value: "youtube", label: "YouTube", price: "Desde 450$ a 1000$" },
  { value: "monthly", label: "Contenido mensual", price: "Desde 600$ (12 videos)" },
  { value: "custom", label: "Personalizado", price: "-", hasInput: true }
];